import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const docLocaleModule: LocaleModule = {
  name: "doc",
  messages: { en: en, it: it },
};
